import { SlotPrimaryAnimationProvider } from '@cgs/machines';
import { Action, EmptyAction } from '@cgs/wge';

export class SantaSlotAnimationProvider extends SlotPrimaryAnimationProvider {
  public buildShortWinLinesAction(): Action {
    return new EmptyAction();
  }

  public buildWinLinesAction(): Action {
    return new EmptyAction();
  }

  public buildSpecialWinLinesAction(): Action {
    return new EmptyAction();
  }
}
